
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

define('component!LoginComponent',['require','prop-types','react','lib/Podio.Transport','component!LoginFormComponent','component!LoginProviderComponent','component!SecondFactorFormComponent','component!ButtonComponent','translate','lib/Podio.Timezone','lib/Podio.Routes','lib/Podio.Utils','lib/Podio.Colors','lib/Podio.UI.FlashMessage','lib/Podio.SingleSignOn'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var transport = require('lib/Podio.Transport');
  var LoginFormComponent = require('component!LoginFormComponent');
  var LoginProviderComponent = require('component!LoginProviderComponent');
  var SecondFactorFormComponent = React.createFactory(require('component!SecondFactorFormComponent'));
  var Button = require('component!ButtonComponent');

  var t = require('translate');
  var podioTimezone = require('lib/Podio.Timezone');
  var routes = require('lib/Podio.Routes');
  var PodioUtils = require('lib/Podio.Utils');
  var PodioColors = require('lib/Podio.Colors');

  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var singleSignOn = require('lib/Podio.SingleSignOn');

  var translations = {
    'being_redirected': t('You are being redirected... #react_login'),
    'podio_sign_in': t('Sign In with Podio #react_login'),
    'provider_sign_in': t('Sign In with Other #react_login'),
    'remember_me': t('Remember me #react_login'),
    'email': t('Email #react_login'),
    'password': t('Password #react_login'),
    'no_account': t('Don\'t have an account? #react_login'),
    'sign_in': t('Sign In #react_login'),
    'sign_up': t('Sign up #react_login'),
    'forgot_password': t('Forgot password? #react_login'),
    'invalid_email': t('This email address is not valid. #react_login'),
    'required_field': t('This field is required. #react_login'),
    'signin_welcome': t('Welcome to Podio! #react_login'),
    'signin_description': t('Use your account information to sign in. #react_login'),
    'signin_button': t('Sign in with {0} #react_login'),
    'sign_in_recovery_code': t('Sign in with a recovery code #mfa'),
    'no_auth_app': t('Dont have access to your authenticator app? #mfa'),
    'invalid_otp': t('Invalid auth code #mfa'),
    'invalid_recoveryCode': t('Invalid recovery code #mfa')
  };

  var secondFactorTranslations = {
    podio_otp: t('Enter your two-step verification code #mfa'),
    use_code_from_app: t('Use the code from your authenticator app #mfa'),
    podio_recovery_code: t('Enter a recovery code #mfa'),
    use_code_from_recovery_list: t('Use the code from your recovery code list #mfa'),
    code_verify: t('Verify #mfa'),
    cancel_code_verify: t('Back to sign in #mfa'),
    otp: t('Enter Code #mfa'),
    recoveryCode: t('Enter Code #mfa')
  };

  var singleProvider = undefined;
  var qs = PodioUtils.querystring();
  var isSingleProviderLogin = Object.keys(qs).some(function (key, i) {
    if (key === 'provider' && singleSignOn.providerOptions[qs[key]]) {
      singleProvider = qs[key];
      return true;
    }
  });

  // All login page SSO providers for main view
  var providers = {};
  Object.keys(singleSignOn.providerOptions).forEach(function (provider, i) {
    if (!!singleSignOn.providerOptions[provider].login) {
      providers[provider] = singleSignOn.providerOptions[provider];
    }
  });

  var LoginComponent = (function (_React$Component) {
    _inherits(LoginComponent, _React$Component);

    function LoginComponent(props) {
      _classCallCheck(this, LoginComponent);

      _get(Object.getPrototypeOf(LoginComponent.prototype), 'constructor', this).call(this, props);
      this.displayName = 'LoginComponent';
      this.state = {
        email: '',
        password: '',
        return_to: props.return_to,
        remember_me: true,
        valid_input: {
          email: { invalid: false, errorMessage: '' },
          password: { invalid: false, errorMessage: '' },
          otp: { invalid: false, errorMessage: '' },
          recoveryCode: { invalid: false, errorMessage: '' }
        },
        isSubmitting: false,
        openSecondFactorForm: false,
        nonce: '',
        useRecoveryCode: false,
        otp: '',
        recoveryCode: ''
      };
    }

    _createClass(LoginComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (podioTimezone) {
          var tzFields = document.querySelectorAll('input[name=timezone]');
          for (var i = 0; i < tzFields.length; i++) {
            tzFields[i].value = podioTimezone.detectTimeZone().olson_tz;
          }
        }
        singleSignOn.signals.onOAuthComplete.add(this.onOAuthCompleted);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this = this;

        var handleSubmitDelegate = function handleSubmitDelegate(e) {
          return _this.handleSubmitDelegate(e);
        };
        var handleSecondFactorSubmitDelegate = function handleSecondFactorSubmitDelegate(e) {
          return _this.handleSecondFactorSubmitDelegate(e);
        };
        var toggleSecondFactor = function toggleSecondFactor(e) {
          return _this.toggleSecondFactor(e);
        };
        var backToSignInDelegate = function backToSignInDelegate(e) {
          return _this.backToSignInDelegate(e);
        };
        var handleInputBlurDelegate = function handleInputBlurDelegate(e) {
          return _this.handleInputBlurDelegate(e);
        };
        var handleInputChangeDelegate = function handleInputChangeDelegate(e) {
          return _this.handleInputChangeDelegate(e);
        };
        var handleKeyPress = function handleKeyPress(e) {
          return _this.handleKeyPress(e);
        };
        var onProviderClick = function onProviderClick(e) {
          return _this.onProviderClick(e);
        };
        var onSingleProviderClick = function onSingleProviderClick(e) {
          return _this.onProviderClick(singleProvider, null);
        };

        if (isSingleProviderLogin) {
          return React.createElement(
            'div',
            { className: 'login-component' },
            React.createElement(
              'div',
              { className: 'login-component__provider' },
              React.createElement(
                'h2',
                { className: 'login-component__provider__header' },
                translations.signin_welcome
              ),
              React.createElement(
                'p',
                { className: 'login-component__provider__description' },
                translations.signin_description
              ),
              React.createElement(Button, {
                label: translations.signin_button.format(singleSignOn.providerOptions[singleProvider].humanizedName),
                onClick: onSingleProviderClick,
                id: 'providerLoginButton' })
            )
          );
        } else {
          if (this.state.openSecondFactorForm) {
            return React.createElement(
              'div',
              { className: 'login-component' },
              React.createElement(
                'div',
                { className: 'login-component__form' },
                React.createElement(SecondFactorFormComponent, {
                  useRecoveryCode: this.state.useRecoveryCode,
                  onBackToSignIn: backToSignInDelegate,
                  onSubmit: handleSecondFactorSubmitDelegate,
                  onKeyPress: handleKeyPress,
                  onChange: handleInputChangeDelegate,
                  onBlur: handleInputBlurDelegate,
                  validation: this.state.valid_input,
                  isSubmitting: this.state.isSubmitting,
                  translations: secondFactorTranslations,
                  otp: this.state.otp,
                  recoveryCode: this.state.recoveryCode
                }),
                !(this.state.isSubmitting || this.state.useRecoveryCode) && React.createElement(
                  'div',
                  { className: 'login-component__signup' },
                  translations.no_auth_app,
                  ' ',
                  React.createElement('br', null),
                  React.createElement(
                    'a',
                    { onClick: toggleSecondFactor, href: '#', className: 'login-component__signup__link' },
                    translations.sign_in_recovery_code
                  )
                )
              )
            );
          } else {
            return React.createElement(
              'div',
              { className: 'login-component' },
              React.createElement(
                'div',
                { className: 'login-component__form' },
                React.createElement(LoginFormComponent, {
                  email: this.state.email,
                  password: this.state.password,
                  return_to: this.state.return_to,
                  remember_me: this.state.remember_me,
                  translations: translations,
                  onSubmit: handleSubmitDelegate,
                  onBlur: handleInputBlurDelegate,
                  validation: this.state.valid_input,
                  onChange: handleInputChangeDelegate,
                  isSubmitting: this.state.isSubmitting,
                  onKeyPress: handleKeyPress })
              ),
              React.createElement(
                'div',
                { className: 'login-component__signup' },
                translations.no_account,
                ' ',
                React.createElement(
                  'a',
                  { className: 'login-component__signup__link', href: '/signup' },
                  translations.sign_up
                )
              ),
              React.createElement(LoginProviderComponent, {
                translations: translations,
                onProviderClick: onProviderClick,
                providers: providers })
            );
          }
        }
      }
    }, {
      key: 'onOAuthCompleted',
      value: function onOAuthCompleted(data) {
        if (data.state === 'contact' || data.state === 'invite' || data.state === 'signin' || data.state === 'signup') {

          window.location.href = data.redirect_url;
          window.focus();
        }
      }
    }, {
      key: 'toggleSecondFactor',
      value: function toggleSecondFactor(e) {
        e.preventDefault();
        this.setState({
          useRecoveryCode: !this.state.useRecoveryCode,
          valid_input: {
            email: { invalid: false, errorMessage: '' },
            password: { invalid: false, errorMessage: '' },
            otp: { invalid: false, errorMessage: '' },
            recoveryCode: { invalid: false, errorMessage: '' }
          },
          otp: '',
          recoveryCode: ''
        });
      }
    }, {
      key: 'handleSecondFactorSubmitDelegate',
      value: function handleSecondFactorSubmitDelegate(e) {
        e.preventDefault();
        var self = this;

        this.setState({
          isSubmitting: true
        });

        var requestData = {
          secondFactor: this.state.otp,
          nonce: this.state.nonce,
          return_to: this.state.return_to,
          remember_me: this.state.remember_me,
          use_recovery_code: this.state.useRecoveryCode
        };

        if (this.state.useRecoveryCode) {
          requestData.secondFactor = this.state.recoveryCode;
        }

        var promise = transport.postJSON('verify_mfa', {
          'requestData': requestData
        });

        promise.done(function (responseData) {
          if (responseData.status === 'ok' && !responseData.message) {
            pendo.track("2SV_login_completed", {
              message: translations.being_redirected
            });
            flashMessage.show(translations.being_redirected, 'notice');
            window.location = responseData.data.redirect_url;
          } else if (responseData.message === 'invalid_second_factor') {
            if (self.state.useRecoveryCode) {
              pendo.track("2SV_login_RC_failure", {
                message: t('wrong recovery code #mfa')
              });
              flashMessage.show(t('wrong recovery code #mfa'), 'error');
            } else {
              pendo.track("2SV_login_OTP_failure", {
                message: t('wrong otp code #mfa')
              });
              flashMessage.show(t('wrong otp code #mfa'), 'error');
            }
            self.setState({
              isSubmitting: false,
              otp: '',
              recoveryCode: ''
            });
          } else if (responseData.message === 'nonce_validation_error') {
            pendo.track("Five_2SV_login_attempts_error", {
              message: t('too many second factor attempts #mfa')
            });
            flashMessage.show(t('too many second factor attempts #mfa'), 'error');
            self.backToSignInDelegate(e);
          }
        });
      }
    }, {
      key: 'backToSignInDelegate',
      value: function backToSignInDelegate(e) {
        e.preventDefault();
        this.setState({
          email: '',
          password: '',
          valid_input: {
            email: { invalid: false, errorMessage: '' },
            password: { invalid: false, errorMessage: '' },
            otp: { invalid: false, errorMessage: '' },
            recoveryCode: { invalid: false, errorMessage: '' }
          },
          isSubmitting: false,
          openSecondFactorForm: false,
          nonce: '',
          useRecoveryCode: false,
          otp: '',
          recoveryCode: ''
        });
      }
    }, {
      key: 'handleSubmitDelegate',
      value: function handleSubmitDelegate(e) {
        e.preventDefault();
        var self = this;
        var _state = this.state;
        var email = _state.email;
        var password = _state.password;
        var return_to = _state.return_to;
        var remember_me = _state.remember_me;

        var promise = transport.postJSON('login_clientside', {
          'requestData': { email: email, password: password, return_to: return_to, remember_me: remember_me }
        });

        this.setState({
          isSubmitting: true
        });

        promise.done(function (responseData) {
          if (responseData.status === 'ok' && !responseData.message) {

            if (!responseData.data.server_nonce) {
              pendo.track("login_without_2SV_completed", {
                message: translations.being_redirected
              });
              flashMessage.show(translations.being_redirected, 'notice');
              window.location = responseData.data.redirect_url;
              return;
            }

            self.setState({
              nonce: responseData.data.server_nonce,
              openSecondFactorForm: true,
              isSubmitting: false
            });

            //remove the message 'You have been logged out.' from the page
            var loggedout_message = document.getElementsByClassName('form-messages notice form-messages__notice')[0];
            if (loggedout_message) {
              loggedout_message.remove();
            }
          } else {
            pendo.track("Invalid_credentials", {
              message: responseData.message
            });
            flashMessage.show(responseData.message, 'error');
            self.setState({
              isSubmitting: false
            });
          }
        });
      }
    }, {
      key: 'handleInputChangeDelegate',
      value: function handleInputChangeDelegate(event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        this.setState(_defineProperty({}, name, value));
      }
    }, {
      key: 'handleInputBlurDelegate',
      value: function handleInputBlurDelegate(event) {
        this.validateField(event.target);
      }
    }, {
      key: 'validateField',
      value: function validateField(field) {
        var updatedField = {
          invalid: false,
          errorMessage: ''
        };

        if (field.required && !field.value) {
          updatedField.invalid = true;
          updatedField.errorMessage = translations.required_field;
        }

        if (field.type === 'email' && field.value) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          if (!re.test(field.value)) {
            updatedField.invalid = true;
            updatedField.errorMessage = translations.invalid_email;
          }
        } else if (field.name === 'otp' && field.value) {

          if (field.value.length != 6) {
            updatedField.invalid = true;
            updatedField.errorMessage = translations.invalid_otp;
          }
        } else if (field.name === 'recoveryCode' && field.value) {

          if (field.value.length != 10) {
            updatedField.invalid = true;
            updatedField.errorMessage = translations.invalid_recoveryCode;
          }
        }

        field.title = updatedField.errorMessage;
        field.setCustomValidity(updatedField.errorMessage);

        this.setState({
          valid_input: _extends({}, this.state.valid_input, _defineProperty({}, field.name, _extends({}, updatedField)))
        });
      }
    }, {
      key: 'handleKeyPress',
      value: function handleKeyPress(e) {
        if (e.which === 13) {
          e.preventDefault();
          e.currentTarget.querySelector('button[type="submit"]').click();
        }
      }
    }, {
      key: 'onProviderClick',
      value: function onProviderClick(provider, event) {
        var _this2 = this;

        var url = routes.sso_start_path() + '?provider=' + provider;
        var ssoProps = ['return_to', 'offering_id', 'subtype', 'remember_me', 'timezone', 'source_id', 'source_type'];

        ssoProps.forEach(function (prop) {
          if (_this2.props[prop]) {
            url += '&' + prop + '=' + _this2.props[prop];
          }
        });

        singleSignOn.popup(url, singleSignOn.providerOptions[provider].width, singleSignOn.providerOptions[provider].height);
      }
    }]);

    return LoginComponent;
  })(React.Component);

  LoginComponent.propTypes = {
    return_to: PropTypes.string.isRequired,
    offering_id: PropTypes.string,
    subtype: PropTypes.string,
    remember_me: PropTypes.string,
    timezone: PropTypes.string,
    source_id: PropTypes.string,
    source_type: PropTypes.string
  };

  LoginComponent.defaultProps = {};

  return LoginComponent;
});
